import "./GlobalStatusOverlay.css";
import {
  FaCoffee,
  FaCheckCircle,
  FaExclamationTriangle,
} from "react-icons/fa";

export default function GlobalStatusOverlay({
  visible,
  status,
  title,
  message,
  onClose,
}) {
  if (!visible) return null;

  const isProcessing = status === "processing";
  const isSuccess = status === "success";
  const isError = status === "error";

  const Icon = isProcessing
    ? FaCoffee
    : isSuccess
    ? FaCheckCircle
    : FaExclamationTriangle;

  const messages = {
    processing: [
      "We're sending emails one by one ☕. This may take a moment...",
      "Grab a coffee while we send all the mails in the background! ☕",
      "Processing in background... Feel free to continue your work! 💼",
    ],
    success: [
      "All your selected bills have been sent via email. 📧",
      "Your selected bills are flying to inboxes. 🚀",
      "Success! Every selected bill is now emailed. ✅",
    ],
    error: [
      "Something went wrong while sending emails. 😕",
      "Couldn't send emails — please try again later. ⚠️",
      "Email delivery failed. Check your network or try again. 🔄",
    ],
  };

  const getMessage = (type) =>
    message || messages[type][Math.floor(Math.random() * messages[type].length)];

  const currentMessage = isProcessing
    ? getMessage("processing")
    : isSuccess
    ? getMessage("success")
    : getMessage("error");

  const theme = {
    processing: { color: "#ffbb33" },
    success: { color: "#33cc66" },
    error: { color: "#ff3333" },
  }[status];

  const getButtonText = () => {
    if (isProcessing) return "Got It 👍";
    if (isSuccess) return "Okay 👍";
    if (isError) return "Try Again 🔁";
  };

  return (
    <div className="overlay-fullscreen fade-in">
      <div className="overlay-content">
        <Icon size={80} color={theme.color} className="overlay-icon-glow" />
        <h1 className="overlay-title">
          {title ||
            (isProcessing
              ? "Processing..."
              : isSuccess
              ? "Emails Sent!"
              : "Error Sending Emails")}
        </h1>
        <p className="overlay-message">{currentMessage}</p>

        <button
          onClick={onClose}
          className="overlay-close-btn"
          style={{ backgroundColor: theme.color }}
        >
          {getButtonText()}
        </button>
      </div>
    </div>
  );
}